import { render, staticRenderFns } from "./DeliveriesMassiveSetPartner.vue?vue&type=template&id=193379c2&scoped=true&lang=pug&"
import script from "./DeliveriesMassiveSetPartner.vue?vue&type=script&lang=js&"
export * from "./DeliveriesMassiveSetPartner.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesMassiveSetPartner.vue?vue&type=style&index=0&id=193379c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193379c2",
  null
  
)

export default component.exports